<template>
  <div id="main">
    <div class="frame-content">
      <div>
        <div class="Modal--widgetLauncherShown">
          <div class="Modal__Body Modal__Body--fullHeight">
            <div id="ComposeMessage" class="SendSmsPage">
              <!-- Header container -->
              <div
                class="SendSmsPage__HeaderContainer"
                style="background-color: #019eaa"
              >
                <div
                  class="SendSmsPage__CurrentLocation SendSmsPage__CurrentLocation--single"
                >
                  <h1 style="margin: 0">
                    <div
                      class="SendSmsPage__CurrentLocationName SendSmsPage__CurrentLocationName--single"
                    >
                      <div class="SendSmsPage__CurrentLocationMessageIcon">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          height="18px"
                          width="18px"
                          viewBox="0 0 24 24"
                        >
                          <path
                            fill="rgba(255,255,255,.4)"
                            fill-rule="evenodd"
                            d="M22 3v13h-11.643l-4.357 3.105v-3.105h-4v-13h20zm2-2h-24v16.981h4v5.019l7-5.019h13v-16.981zm-5 6h-14v-1h14v1zm0 2h-14v1h14v-1zm-6 3h-8v1h8v-1z"
                          />
                        </svg>
                      </div>
                      We'll text you.
                    </div>
                  </h1>
                </div>
              </div>
              <form
                id="chat-form"
                name="widget-form"
                class="SendSmsPage__MainContent"
                novalidate=""
                ref="chatWidgetMainForm"
              >
                <loading
                  v-model:active="isLoading"
                  :can-cancel="false"
                  :is-full-page="false"
                  transition="fade"
                  color="#000"
                  loader="spinner"
                />
                <!-- spacer -->
                <div class="SendSmsPage__Spacer"></div>
                <!-- submit button form -->
                <div class="SendSmsPage__ButtonFader">
                  <div
                    v-if="!isMessageSent && locationInfo"
                    class="Legal Legal--isActive"
                  >
                    <p id="legalText" class="Legal__text truncate">
                      If this is an emergency, call 911 or go to the nearest ER.
                      By submitting, you authorize
                      {{ locationInfo.locationName }} to send text messages with
                      offers &amp; other info, possibly using automated
                      technology. Message rates may apply. Consent is not a
                      condition of purchase.
                    </p>
                    <!-- <input
                      class="button"
                      type="button"
                      style="
                        font-size: 11px;
                        padding: 0px;
                        background-color: transparent;
                      "
                      value="Read Less"
                      @click="changeToggle(false)"
                    /> -->
                  </div>

                  <div class="SendSmsPage__Center">
                    <!-- SendButton--valid - for removing disabled to valid -->
                    <button
                      aria-label="submit message"
                      class="SendButton"
                      tabindex="6"
                      id="submit-button"
                      ref="chatFormSubmitButton"
                      @click.prevent="submitDataToMnv"
                      v-if="!isMessageSent"
                      :class="[
                        disableSubmitButton
                          ? 'SendButton--incomplete'
                          : 'SendButton--valid',
                      ]"
                    >
                      <div class="SendButton__Fader SendButton__Fader--visible">
                        Send
                      </div>
                    </button>
                  </div>
                </div>
                <!-- form container -->
                <div class="SendSmsPage__FormContainer">
                  <div
                    id="SendSmsPage__TextInvitation_id"
                    class="SendSmsPage__TextInvitation"
                    ref="SendSmsPage__TextInvitation_id"
                  >
                    <div>
                      Enter your details below. Our team will text you shortly.
                    </div>
                  </div>
                  <!-- form content -->
                  <div
                    id="sendSMSform"
                    class="SendSmsPage__FormContent custom-loading-svg"
                    v-if="!isMessageSent"
                  >
                    <div class="TextInput">
                      <input
                        class="TextInput__FormInput"
                        required=""
                        id="fullName"
                        autocomplete="name"
                        type="text"
                        tabindex="1"
                        v-model="chatData.fullName"
                      /><label for="fullName" id="widget-fullName-label"
                        >Name*</label
                      >
                      <div class="TextInput__Bar"></div>
                      <div
                        class="TextInput__TextInputError"
                        v-if="fullNameError"
                        aria-live="polite"
                      >
                        Name is required
                      </div>
                    </div>
                    <div class="TextInput TextInput--tel">
                      <input
                        class="TextInput__FormInput"
                        required=""
                        id="phoneNumber"
                        autocomplete="tel"
                        type="tel"
                        tabindex="2"
                        v-model="chatData.phoneNumber"
                        ref="chatPhoneNumber"
                        maxlength="16"
                      /><label for="phoneNumber" id="widget-phoneNumber-label"
                        >Mobile Number*</label
                      >
                      <div class="TextInput__Bar"></div>
                      <div
                        class="TextInput__TextInputError TextInput__TextInputError--tel"
                        v-if="phoneNumberError || phoneNumberFormatError"
                        aria-live="polite"
                      >
                        {{
                          phoneNumberFormatError
                            ? "Wrong format"
                            : "Mobile phone is required"
                        }}
                      </div>
                    </div>
                    <div class="TextInput">
                      <!-- <div class="customLabel">New patient?*</div> -->
                      <select
                        aria-placeholder="New patient?*"
                        class="selectpatient"
                        v-model="isExistingPatient"
                        name="MultipleSelect"
                        tabindex="3"
                        id="multipleselect"
                      >
                        <option value="false" selected disabled>
                          New patient?*
                        </option>

                        <option value="New Patient">Yes</option>
                        <option value="Existing Patient">No</option>
                      </select>
                      <div class="TextInput__Bar"></div>
                    </div>
                    <div class="TextInput TextInput--message">
                      <textarea
                        class="TextInput__Textarea textarea-full"
                        required=""
                        id="messageText"
                        tabindex="4"
                        style="resize: none; overflow: hidden"
                        ref="messageText"
                        v-model="chatData.messageText"
                        maxlength="300"
                      ></textarea
                      ><label for="messageText">Message*</label>
                      <div class="TextInput__Bar"></div>
                      <div
                        class="TextInput__TextInputError"
                        v-if="messageTextError"
                        aria-live="polite"
                      >
                        Message is required
                      </div>
                    </div>

                    <!-- Text message character count -->
                    <div class="SendSmsPage__BelowFormRow">
                      <div class="message-char-count">
                        <div
                          style="font-size: 0.8rem"
                          :style="`color:${
                            chatData.messageText.length === 300 ? 'red' : 'grey'
                          }`"
                        >
                          {{ chatData.messageText.length }}/300
                        </div>
                      </div>
                    </div>
                  </div>
                  <!-- Test number and message view -->
                  <div
                    id="submittedMessage"
                    class="SubmittedMessage SubmittedMessage--visible"
                    style="background-color: rgba(48, 116, 220, 0.12)"
                    v-if="isMessageSent"
                  >
                    <div
                      id="submittedMessageTitle"
                      class="SubmittedMessage__Title"
                    >
                      <!-- ●●●●●●●●{{
                        sentphoneNumber.trim().length > 0
                          ? sentphoneNumber
                              .split("")
                              .reverse()
                              .join("")
                              .slice(0, 4)
                              .split("")
                              .reverse()
                              .join("")
                          : ""
                      }} -->
                      {{ sentphoneNumber }}
                    </div>
                    <div id="submittedMessageMessage">
                      {{ sentMessage }}
                    </div>
                  </div>
                  <!-- received tag -->
                  <div
                    id="submitMessageStatus"
                    class="SubmittedMessage__SendStatus"
                    v-if="isMessageSent"
                  >
                    <p>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="10px"
                        height="10px"
                        viewBox="0 0 24 24"
                      >
                        <path
                          d="M5.48 10.089l1.583-1.464c1.854.896 3.028 1.578 5.11 3.063 3.916-4.442 6.503-6.696 11.311-9.688l.516 1.186c-3.965 3.46-6.87 7.314-11.051 14.814-2.579-3.038-4.301-4.974-7.469-7.911zm14.407.557c.067.443.113.893.113 1.354 0 4.962-4.038 9-9 9s-9-4.038-9-9 4.038-9 9-9c1.971 0 3.79.644 5.274 1.723.521-.446 1.052-.881 1.6-1.303-1.884-1.511-4.271-2.42-6.874-2.42-6.075 0-11 4.925-11 11s4.925 11 11 11 11-4.925 11-11c0-1.179-.19-2.313-.534-3.378-.528.633-1.052 1.305-1.579 2.024z"
                        />
                      </svg>
                      Received
                    </p>
                  </div>
                  <!-- ConfirmationMessage of our team will contact -->
                  <div
                    id="confirmationMessageContainer"
                    class="ConfirmationMessage"
                    v-if="isMessageSent"
                  >
                    <div
                      class="ConfirmationMessage__PhoneNumber"
                      style="color: #019eaa"
                    >
                      {{ locationInfo.twilioFromNumber }}
                    </div>
                    <div
                      class="ConfirmationMessage__Message"
                      aria-live="polite"
                    >
                      <div class="ConfirmationMessage__Title">
                        We received your message.
                      </div>
                      <div class="ConfirmationMessage__Subtitle">
                        <p>
                          Our team will be texting you back from the number
                          above.
                        </p>
                      </div>
                      <div class="ConfirmationMessage__Check">
                        <div class="TextInput__Checkmark">
                          <svg
                            clip-rule="evenodd"
                            fill-rule="evenodd"
                            stroke-linejoin="round"
                            stroke-miterlimit="2"
                            viewBox="0 0 24 24"
                            xmlns="http://www.w3.org/2000/svg"
                            height="22px"
                            width="22px"
                          >
                            <path
                              style="fill: green"
                              d="m2.25 12.321 7.27 6.491c.143.127.321.19.499.19.206 0 .41-.084.559-.249l11.23-12.501c.129-.143.192-.321.192-.5 0-.419-.338-.75-.749-.75-.206 0-.411.084-.559.249l-10.731 11.945-6.711-5.994c-.144-.127-.322-.19-.5-.19-.417 0-.75.336-.75.749 0 .206.084.412.25.56"
                              fill-rule="nonzero"
                            />
                          </svg>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </form>
              <!-- powered by media nv text -->
              <div
                class="MnvPower__Container MnvPower__Container--noMarginBottom MnvPower__Container--whiteBottom"
              >
                <div>
                  <span class="bullet">Crafted with</span>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="12px"
                    height="12px"
                    viewBox="0 0 24 24"
                    style="fill: red; width: 15px !important"
                  >
                    <path
                      d="M12 4.248c-3.148-5.402-12-3.825-12 2.944 0 4.661 5.571 9.427 12 15.808 6.43-6.381 12-11.147 12-15.808 0-6.792-8.875-8.306-12-2.944z"
                    />
                  </svg>
                  <span class="bullet">by</span>
                </div>
                <div class="terms">
                  <a
                    href="https://medianv.com/"
                    target="_blank"
                    rel="noopener noreferrer"
                    >MediaNV</a
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import "./ChatWidget.css";
import axios from "axios";
import { ElMessage } from "element-plus";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/css/index.css";

export default {
  name: "ChatWidgetForm",
  components: {
    Loading,
  },
  data() {
    return {
      isExistingPatient: "false",
      chatWidgetUrl: "",
      readMoreToggle: false,
      chatData: {
        fullName: "",
        phoneNumber: "",
        messageText: "",
        event: "",
        customerCode: "",
        locationCode: "",
      },
      error: {
        title: "",
        message: "",
      },
      isMessageSent: false,
      sentphoneNumber: "",
      sentMessage: "",
      isShowError: false,
      mnvCustomerCode: "",
      mnvLocationCode: "",
      locationInfo: null,
      disableSubmitButton: true,
      fullNameError: false,
      phoneNumberError: false,
      phoneNumberFormatError: false,
      messageTextError: false,
      isLoading: false,
      fullPage: true,
    };
  },
  emits: ["messagesent"],
  methods: {
    changeToggle(value) {
      this.readMoreToggle = value;
    },
    submitDataToMnv(e) {
      e.preventDefault();

      // const fields = ["fullName", "phoneNumber"];
      const chatWidgetMainForm = this.$refs.chatWidgetMainForm;
      // let field, label;
      // const contentFormFrame = document.getElementById("mnv-chat-widget-frame");

      // for (let i = 0; i < fields.length; i++) {
      //   field = chatWidgetMainForm[fields[i]];
      //   field.className = field.className.replace(" widget-error", "");
      //   label = contentFormFrame.contentWindow.document.getElementById(
      //     "widget-" + fields[i] + "-label"
      //   ).innerText;
      //   if (!field.value) {
      //     field.className += " widget-error";
      //     alert("Please enter your " + label);
      //     field.focus();
      //     return false;
      //   }
      //   if (!this.validateFields(fields[i], field.value)) {
      //     field.className += " blinker-error";
      //     alert("Please enter a valid " + label);
      //     field.focus();
      //     return;
      //   }
      // }
      if (!this.chatData.fullName) {
        this.fullNameError = true;
      }
      // phone number error
      if (!this.chatData.phoneNumber) {
        this.phoneNumberError = true;
      } else if (
        /^[+]*(1|91)?(\d{3})(\d{3})(\d{4})$/.test(this.chatData.phoneNumber) ==
        false
      ) {
        this.phoneNumberFormatError = true;
      }
      // message error
      if (!this.chatData.messageText) {
        this.messageTextError = true;
      }

      if (
        this.fullNameError ||
        this.phoneNumberError ||
        this.messageTextError
      ) {
        return;
      }
      if (
        this.chatData.fullName &&
        this.chatData.phoneNumber &&
        this.chatData.messageText &&
        this.chatData.phoneNumber.match(/^[+]*(1|91)?(\d{3})(\d{3})(\d{4})$/)
      ) {
        console.log(this.chatData);

        let phoneNumber = `${chatWidgetMainForm["phoneNumber"].value}`;
        this.chatData.phoneNumber = phoneNumber;
        this.chatData.event = "conversation_created";
        this.$refs.chatFormSubmitButton.innerHTML = "Send...";

        let customerCode = this.mnvCustomerCode,
          locationCode = this.mnvLocationCode;

        if (!(customerCode && locationCode)) {
          ElMessage.error(
            "Valid API Key is not available on this page to send the message. Please refresh the page and try again."
          );
          this.error.message =
            "Valid API Key is not available on this page to send the message. Please refresh the page and try again.";
          this.error.title = "Invalid Information";
          this.isShowError = true;
          this.$refs.chatFormSubmitButton.innerHTML = "Send";
          return;
        }

        this.chatData.customerCode = customerCode;
        this.chatData.locationCode = locationCode;
        this.chatData.isExistingPatient = this.isExistingPatient;
        this.chatData.currentWidgetUrl = this.currentWidgetUrl;
        // code here to show the toast message if the customer code and location code
        
        this.isLoading = true;
        axios
          .post(
            `${process.env.VUE_APP_MEDIANV_ENDPOINT_URL_FOR_MESSAGE}`,
            this.chatData
          )
          .then((resp) => {
            this.sentMessage = this.chatData.messageText;
            this.sentphoneNumber = this.chatData.phoneNumber;
            this.$emit("messagesent");
            this.isMessageSent = true;
            this.$refs.chatFormSubmitButton.innerHTML = "Send";
            this.isLoading = false;

          })
          .catch((error) => {
            this.isMessageSent = true;
            console.error(error);
          });
      }
    },
    validateFields(field, value) {
      var regex = /[a-z]{2,}/i;

      // Validate first and last name
      if (field === "fullName") {
        return regex.test(value);
      }

      // Validate phone number
      if (field === "phoneNumber") {
        regex = /^[+]*(1|91)?(\d{3})(\d{3})(\d{4})$/;
        return regex.test(value.toString());
      }
    },
    closeErrorAlert() {
      this.isShowError = false;
    },
    setInformationInChatWidgetForm() {
      this.isLoading = true;

      // calling api to get the information
      axios
        .get(
          `${process.env.VUE_APP_MEDIANV_API_HOST_URL}/customer-config-backend/customers/getcustomers/getChatWidgetRequiredInfo?customerCode=${this.mnvCustomerCode}&&locationCode=${this.mnvLocationCode}`
        )
        .then((resp) => {
          const locationInfo = resp.data.data;
          if (!locationInfo) {
            ElMessage.error("Unable to fetch information for chat");
            return;
          }
          this.locationInfo = locationInfo;
          this.isLoading = false;
        })
        .catch((error) => {
          console.error(error);
          this.isLoading = false;
        });
    },
    checkFormValidation() {
      console.log(this.chatData.phoneNumber);
      if (
        this.chatData.phoneNumber &&
        this.chatData.fullName &&
        this.chatData.messageText &&
        this.isExistingPatient !== "false"
      ) {
        this.disableSubmitButton = false;
      } else {
        this.disableSubmitButton = true;
      }
    },
  },
  mounted() {
    this.currentWidgetUrl = window.location.href;
    const scrollToDiv = this.$refs.SendSmsPage__TextInvitation_id;
    scrollToDiv.scrollIntoView(false);
    this.$refs.messageText.addEventListener("input", function (e) {
      this.style.height = "18px";
      this.style.height = this.scrollHeight + "px";
    });

    const chatWidgetScript = document.getElementById("chat-widget-app");
    let customerCode, locationCode;

    if (chatWidgetScript) {
      //get the chatWidget Apikey from script data
      const chatWidgetApiKey = chatWidgetScript
        .getAttribute("data-client-key")
        .split("#")
        .filter((code) => code);
      customerCode = chatWidgetApiKey[0];
      locationCode = chatWidgetApiKey[1];
    }

    if (
      !(customerCode && locationCode) &&
      process.env.VUE_APP_RUNNING_WITHOUT_WEBSITE === "true"
    ) {
      customerCode = process.env.VUE_APP_CUSTOMER_CODE_CHATWIDGET;
      locationCode = process.env.VUE_APP_LOCATION_CODE_CHATWIDGET;
    }
    if (!(customerCode && locationCode)) {
      ElMessage.error(
        "Valid API Key is not available on this page to send the message. Please refresh the page and try again."
      );
      this.error.message =
        "Valid API Key is not available on this page to send the message. Please refresh the page and try again.";
      this.error.title = "Invalid Information";
      this.isShowError = true;
      this.$refs.chatFormSubmitButton.innerHTML = "Send";
      return;
    }

    this.mnvCustomerCode = customerCode;
    this.mnvLocationCode = locationCode;

    this.setInformationInChatWidgetForm();
  },
  watch: {
    "chatData.fullName": function () {
      this.fullNameError = false;
    },
    "chatData.messageText": function () {
      this.messageTextError = false;
    },
    "chatData.phoneNumber": function (newVal) {
      this.phoneNumberError = false;
      let re = /[^+0-9]/gi;
      this.chatData.phoneNumber = newVal.replace(re, "");

      this.checkFormValidation();
    },
    "chatData.fullName": function () {
      this.checkFormValidation();
    },
    "chatData.messageText": function () {
      this.checkFormValidation();
    },
    isExistingPatient: function () {
      this.checkFormValidation();
    },
  },
};
</script>
<style>
@keyframes stroke {
  100% {
    stroke-dashoffset: 0;
  }
}
.example-showcase .el-loading-mask {
  z-index: 9;
}
.selectpatient {
  resize: none;
  font-family: "Poppins", sans-serif;
  background: none;
  border: 0;
  color: #333;
  font-size: 14px;
  height: 30px;
  outline: none;
  position: relative;
  width: 100%;
  z-index: 1;
  line-height: 1.5;
}
</style>
